__turbopack_context__.v({
  "activeBilling": "pricing-module__BV_6Pq__activeBilling",
  "amount": "pricing-module__BV_6Pq__amount",
  "bestValueTag": "pricing-module__BV_6Pq__bestValueTag",
  "billingToggle": "pricing-module__BV_6Pq__billingToggle",
  "buttonIcon": "pricing-module__BV_6Pq__buttonIcon",
  "checkIcon": "pricing-module__BV_6Pq__checkIcon",
  "comparisonSection": "pricing-module__BV_6Pq__comparisonSection",
  "comparisonTable": "pricing-module__BV_6Pq__comparisonTable",
  "comparisonTitle": "pricing-module__BV_6Pq__comparisonTitle",
  "currency": "pricing-module__BV_6Pq__currency",
  "enterpriseButton": "pricing-module__BV_6Pq__enterpriseButton",
  "enterpriseContent": "pricing-module__BV_6Pq__enterpriseContent",
  "enterpriseFeature": "pricing-module__BV_6Pq__enterpriseFeature",
  "enterpriseFeatures": "pricing-module__BV_6Pq__enterpriseFeatures",
  "enterpriseIcon": "pricing-module__BV_6Pq__enterpriseIcon",
  "enterpriseSection": "pricing-module__BV_6Pq__enterpriseSection",
  "faqGrid": "pricing-module__BV_6Pq__faqGrid",
  "faqItem": "pricing-module__BV_6Pq__faqItem",
  "faqSection": "pricing-module__BV_6Pq__faqSection",
  "faqTitle": "pricing-module__BV_6Pq__faqTitle",
  "featureColumn": "pricing-module__BV_6Pq__featureColumn",
  "featureIcon": "pricing-module__BV_6Pq__featureIcon",
  "featureTooltip": "pricing-module__BV_6Pq__featureTooltip",
  "freePlan": "pricing-module__BV_6Pq__freePlan",
  "highlightColumn": "pricing-module__BV_6Pq__highlightColumn",
  "minSeatsNote": "pricing-module__BV_6Pq__minSeatsNote",
  "period": "pricing-module__BV_6Pq__period",
  "planButton": "pricing-module__BV_6Pq__planButton",
  "planColumn": "pricing-module__BV_6Pq__planColumn",
  "planFeatures": "pricing-module__BV_6Pq__planFeatures",
  "planHeader": "pricing-module__BV_6Pq__planHeader",
  "planIcon": "pricing-module__BV_6Pq__planIcon",
  "planPrice": "pricing-module__BV_6Pq__planPrice",
  "planSubtitle": "pricing-module__BV_6Pq__planSubtitle",
  "popularTag": "pricing-module__BV_6Pq__popularTag",
  "pricingCard": "pricing-module__BV_6Pq__pricingCard",
  "pricingGrid": "pricing-module__BV_6Pq__pricingGrid",
  "pricingSection": "pricing-module__BV_6Pq__pricingSection",
  "primaryPlanButton": "pricing-module__BV_6Pq__primaryPlanButton",
  "proPlan": "pricing-module__BV_6Pq__proPlan",
  "saveBadge": "pricing-module__BV_6Pq__saveBadge",
  "tableComparisonSavings": "pricing-module__BV_6Pq__tableComparisonSavings",
  "tableHeader": "pricing-module__BV_6Pq__tableHeader",
  "tableRow": "pricing-module__BV_6Pq__tableRow",
  "teamPlan": "pricing-module__BV_6Pq__teamPlan",
  "teamPlanButton": "pricing-module__BV_6Pq__teamPlanButton",
  "teamSavingsBadge": "pricing-module__BV_6Pq__teamSavingsBadge",
  "toggleKnob": "pricing-module__BV_6Pq__toggleKnob",
  "toggleSwitch": "pricing-module__BV_6Pq__toggleSwitch",
  "totalPriceNote": "pricing-module__BV_6Pq__totalPriceNote",
  "xIcon": "pricing-module__BV_6Pq__xIcon",
});
